import React from 'react';
import { Container } from 'react-bootstrap';
import { useStoreSettings } from '../contexts/StoreSettingsContext';
import 'quill/dist/quill.snow.css';
import '../components/Footer.css';

const ShippingPolicyPage = () => {
    const { settings } = useStoreSettings();

    return (
        <Container className="py-5">
            <h2 className="mb-4">Shipping Policy</h2>
            {settings.shipping_policy ? (
                <div
                    className="policy-content ql-editor"
                    dangerouslySetInnerHTML={{ __html: settings.shipping_policy }}
                />
            ) : (
                <p className="text-muted">Shipping policy is not configured yet.</p>
            )}
        </Container>
    );
};

export default ShippingPolicyPage;
